<template>
	<div class="app--engagement-error" :class="{'dark' : error}">
        <div>
            <div v-if="error && error == 'cookies-disabled'" class="alert alert-danger d-flex">
                <app-icon value="error"></app-icon>
                <div>
                    <h3>Your browser is blocking 3rd party cookies.</h3>
                    <p>Please enable the use of 3rd party cookies in your browser settings or click below to open in a new window.</p>
                    <p><a :href="url" target="_blank" class="btn btn-secondary">Open in a new window</a></p>
                </div>
            </div>
            <div v-if="!error" class="alert alert-danger d-flex" @click="reload">
                <app-icon value="error"></app-icon>
                <div>
                    <h3>{{$t('app.common.oops')}}</h3>
                    <p>{{$t('app.common.reload')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store'
    export default {
        computed: {
            error() { return store.state.error },
            url()   { return '/w/' + store.state.code }
        },
        methods: {
            reload() { document.location.reload() }
        }
    }
</script>
